import { bootstrapConfig, type BootstrapConfig } from '@solote/contracts';
import { platformApiUrl } from './env';
import { request } from '../http/client';

/**
 * A configuracao e validada na borda. Se o painel publicar algo malformado,
 * o erro aparece aqui, com caminho e motivo, em vez de virar tela branca
 * tres componentes abaixo.
 */
export async function fetchBootstrap(): Promise<BootstrapConfig> {
  /*
    A configuração vem do ACERVO, que é quem a guarda e a publica.

    Enquanto ela morava em `sessionStorage`, editar no painel repintava o
    portal e a alteração sumia ao fechar a aba — o formulário do painel era uma
    maquete cara. Agora ela é dado, e vale para todo mundo.
  */
  const payload = await request<unknown>('/bootstrap', { baseUrl: platformApiUrl });
  const parsed = bootstrapConfig.safeParse(payload);

  if (!parsed.success) {
    const issues = parsed.error.issues
      .slice(0, 5)
      .map((issue) => `${issue.path.join('.')}: ${issue.message}`)
      .join(' | ');
    throw new Error(`Configuracao do site invalida. ${issues}`);
  }

  return parsed.data;
}
